import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: 0px ${props => props.theme.spacing.sp8};
`

export const RefundConceptContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${props => (props.hasError ? props.theme.colors.danger.default : 'inherit')};
`
